Toutou_Transform = function () {

  //Variable de classe
  this.pix_margeg=0;
  this.pix_margeb=0;
  this.dd=0;
  this.xmin=0;
  this.ymin=0;
  this.xmax=0;
  this.ymax=0;
  this.xmin_pix=0;
  this.xmax_pix=0;
  this.ymin_pix=0;
  this.ymax_pix=0;
  this.xind_min=0;
  this.xind_max=0;

  // Variables Privees
  slopex=0.;
  slopey=0.;

  // Methodes
  this.d2px=d2px;
  this.d2py=d2py;
  this.init=init;
  this.xticks_jours=xticks_jours;
  this.xrange=xrange;
  this.draw_model_zones=draw_model_zones;

  function xrange(my_zoom,hhh,staggered){
    //Argument optionel
    if (staggered!=null){
      var my_staggered=staggered;
    } else {
      var my_staggered=0;
    }
    ni=hhh.length;
    if (my_zoom==0){
      this.xmin=hhh.min();
      this.xmax=hhh.max();
      this.xind_min=0;
      this.xind_max=ni-1;
      if (window.gstart_from_now) {
        var hhhc = (datec - dateo) / 3600000;
        if (hhhc > this.xmin && hhhc < this.xmax) {
          var i_now = 0;
          while (i_now < ni - 1 && hhh[i_now] < hhhc) i_now++;
          this.xind_min = Math.max(0, i_now - 1);
          this.xmin = hhh[this.xind_min];
        }
      }
    } else {
      for ( var i=1; i <= zoomind_max; i++) {
        if (my_zoom==i){
	  this.xind_min=Math.round((i-1)*ni/zoomind_max);
	  this.xind_max=Math.min(myJson.hhh.length-1,Math.round(i*ni/zoomind_max));
          this.xmin=hhh[Math.max(0,this.xind_min+my_staggered)];
          this.xmax=hhh[this.xind_max];
	}
      }
    }
  }

  function init(zoom){
    //Argument optionel
    if (zoom!=null){
      var my_zoom=zoom;
    } else {
      var my_zoom=0;
    }
    slopex=(this.pix_marged-this.pix_margeg)/(this.xmax-this.xmin);
    slopey=(this.pix_margeh-this.pix_margeb)/(this.ymax-this.ymin);
    this.xmin_pix=this.d2px(this.xmin); 
    this.xmax_pix=this.d2px(this.xmax); 
    this.ymin_pix=this.d2py(this.ymin); 
    this.ymax_pix=this.d2py(this.ymax);
    this.dd=(this.ymax_pix-this.ymin_pix)*.01;
    if ( my_zoom > 0 ){this.dd=this.dd*zoomind_max/3}
  }

  function d2px(data_x){
    return this.pix_margeg + (data_x-this.xmin)*slopex;
  }
  function d2py(data_y){
    return this.pix_margeb + (data_y-this.ymin)*slopey;
  }

  function xticks_jours(datev,hhh,ctx,my_fonts,zoom,options={}){
    var { staggered, time_label } = options;
    //Argument optionel
    if (staggered!=null){
      var my_staggered=staggered;
    } else {
      var my_staggered=0;
    }
    //Argument optionel
    if (zoom!=null){
      var my_zoom=zoom;
    } else {
      var my_zoom=0;
    }

    var jour='';
    var jourp='';
    var ni=hhh.length;

    // Tracer la boite
    ctx.beginPath();
    ctx.strokeStyle = 'black';
    ctx.moveTo(this.pix_margeg,this.pix_margeh);
    ctx.lineTo(this.pix_marged,this.pix_margeh);
    ctx.lineTo(this.pix_marged,this.pix_margeb);
    ctx.lineTo(this.pix_margeg,this.pix_margeb);
    ctx.lineTo(this.pix_margeg,this.pix_margeh);
    ctx.stroke();
    
    if ( my_zoom > 0 ){
	
	// No du jour en gros
	ctx.font = my_fonts.filigrane_petit;
	ctx.fillStyle = "#FFE0FF";
	ctx.textAlign="center";
	ctx.textBaseline="middle";
      tag=['1 de 3','2 de 3','3 de 3']
	ctx.fillText(tag[my_zoom-1],.5*(this.xmax_pix+this.xmin_pix),.28*(this.ymax_pix+this.ymin_pix));
    }

    // Fleches de zoom en filigran si necessaire
    ctx.fillStyle = "#F0F0FF";
    ctx.beginPath();
    centre_y=.5*(this.ymax_pix+this.ymin_pix);
    // Les 7 points suivants forment on fleche pointant vers la gauche
    //
    //       5
    //       6    7
    //4 
    //       2    1
    //       3
    //
    // Point 1
    el=-10*this.dd
    ctx.moveTo(this.pix_margeg+3*el,centre_y+el);
    // point 2
    ctx.lineTo(this.pix_margeg+2*el,centre_y+el);
    // point 3
    ctx.lineTo(this.pix_margeg+2*el,centre_y+2*el);
    //point 4
    ctx.lineTo(this.pix_margeg     ,centre_y);
    //point 5
    ctx.lineTo(this.pix_margeg+2*el,centre_y-2*el);
    //point 6
    ctx.lineTo(this.pix_margeg+2*el,centre_y-el);
    //point 7
    ctx.lineTo(this.pix_margeg+3*el,centre_y-el);
    ctx.closePath();
    ctx.fill();
    
    // Les 7 points suivants forment on fleche pointant vers la droite
    //
    //     5
    //7    6    
    //            4
    //1    2 
    //     3
    //
    // Point 1
    ctx.moveTo(this.xmax_pix-3*el,centre_y+el);
    // point 2
    ctx.lineTo(this.xmax_pix-2*el,centre_y+el);
    // point 3
    ctx.lineTo(this.xmax_pix-2*el,centre_y+2*el);
    //point 4
    ctx.lineTo(this.xmax_pix     ,centre_y);
    //point 5
    ctx.lineTo(this.xmax_pix-2*el,centre_y-2*el);
    //point 6
    ctx.lineTo(this.xmax_pix-2*el,centre_y-el);
    //point 7
    ctx.lineTo(this.xmax_pix-3*el,centre_y-el);
    ctx.closePath();
    ctx.fill();
    //ctx.stroke();
    
    // iMeteo.ca en filigran
    ctx.font = my_fonts.filigrane;
    ctx.fillStyle = "#F0F0FF";
    ctx.textAlign="center";
    ctx.textBaseline="middle";
    ctx.fillText('iMeteo.ca',.5*(this.xmax_pix+this.xmin_pix),.5*(this.ymax_pix+this.ymin_pix));
    
    // Tracer une ligne pour l'heure courrante
    hhhc=(datec-dateo)/(3600.*1000.);
    xx=Math.round(this.d2px(hhhc))+.5;
    ctx.beginPath();
    ctx.moveTo(xx,this.ymin_pix);
    ctx.lineTo(xx,this.ymax_pix);
    ctx.stroke();

    ctx.beginPath();
    ctx.font = my_fonts.axis;
    ctx.fillStyle = "black";
    ctx.strokeStyle = 'black';
    ctx.textBaseline="top";
    var yy=Math.round(this.ymin_pix-.025*(this.ymax_pix-this.ymin_pix))+.5;
    var yy2=Math.round(this.ymin_pix-.1*(this.ymax_pix-this.ymin_pix))+.5;      
    var yy3=Math.round(this.ymin_pix-.175*(this.ymax_pix-this.ymin_pix))+.5;
    // Draw minor ticks at every hour
    for (var i=Math.max(0,hhh[this.xind_min+my_staggered]); i <= hhh[this.xind_max]; i++) {
        xx=Math.round(this.d2px(i))+.5;
	ctx.moveTo(xx,this.ymin_pix);
	ctx.lineTo(xx,yy);
    }
    for (var i=Math.max(0,this.xind_min+my_staggered); i <= this.xind_max; i++) {
      xx=Math.round(this.d2px(hhh[i]))+.5;
      ctx.moveTo(xx,this.ymin_pix);
      ctx.lineTo(xx,yy);
      datev.setHours(datev.getHours()+hhh[i]);
      if(time_label){
	//time_label[i]=datev.getJour()+' '+datev.getDate()+' '+datev.getMois()+' '+datev.getHours()+'h';
       time_label[i]=datev.getHours()+'h, '+datev.getJour()+' '+datev.getDate()+' '+datev.getMois();
      }
      ctx.textAlign="center";
      // Write x labels
      write=i%2 == 0; // Labels at every 2 be default
      if(hhh[i] <= 12){
	write=i%3 == 0; // Labels at every 3 up to 12 h
      }
      if ( hhh[i] >= 72){
	write=true; // Write all labels at and after 72 h
      }
      if ( zoom ){
	write=true; // Write all labels if x is zoomed
      }
      if (write) {
         ctx.fillText(datev.getHours(),xx,yy);
      }	    
      if(i == 0){
	ctx.textAlign="center";
	jour=datev.getJour();
	ctx.fillText(jour,xx,yy2);
	jourp=jour;
      }else{
	ctx.textAlign="left";
	jour=datev.getJour();
	if(jour != jourp){
	  if(hhh[i]==hhh[ni-1]){
             ctx.textAlign="center";
          }
	  ctx.fillText(jour,xx,yy2);
	  jourp=jour;
	}
      }
      datev.setHours(datev.getHours()-hhh[i]);
    }
    ctx.stroke();
    ctx.textAlign="center"; 
    if(gdate_utc_offset >= 0){
      ctx.fillText("Heure locale (UTC -"+gdate_utc_offset/60+")",.5*(this.xmax_pix+this.xmin_pix),yy3);
    }else{
      ctx.fillText("Heure locale (UTC "+(-1*gdate_utc_offset/60)+")",.5*(this.xmax_pix+this.xmin_pix),yy3);
    }
    ctx.stroke();
  }

  function draw_model_zones(ctx, my_fonts, hhh, modele) {
    var ya_offset = Math.round(parseInt(my_fonts.legende) * window.devicePixelRatio * 0.23);
    var h_rdps = 48, h_gdps = 84;
    if (hhh && modele) {
      for (var i = 1; i < hhh.length; i++) {
        if (modele[i] === 'R' && modele[i-1] === 'H') h_rdps = hhh[i];
        if (modele[i] === 'G' && modele[i-1] === 'R') h_gdps = hhh[i];
      }
    }
    var chart_left  = this.pix_margeg;
    var chart_right = this.pix_marged;
    var x48 = Math.min(Math.max(this.d2px(h_rdps), chart_left), chart_right);
    var x84 = Math.min(Math.max(this.d2px(h_gdps), chart_left), chart_right);
    var ya  = Math.round(this.pix_margeh + ya_offset) + .5;
    var arr = Math.round(parseInt(my_fonts.legende) * window.devicePixelRatio * 0.20);
    var sep = 4;
    var font_size = Math.round(parseInt(my_fonts.legende) * 0.8);
    var font_family = my_fonts.legende.replace(/^\d+px/, font_size + 'px');
    ctx.font = font_family;
    ctx.strokeStyle = '#999';
    ctx.fillStyle = '#999';
    ctx.lineWidth = 1;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    // HRDPS
    var tw = ctx.measureText('HRDPS').width + 8;
    var xm = (chart_left + x48) / 2;
    ctx.beginPath();
    if (x48 - chart_left > arr * 2 + sep + tw) {
      ctx.moveTo(chart_left + arr, ya); ctx.lineTo(xm - tw/2, ya);
      ctx.moveTo(xm + tw/2, ya);        ctx.lineTo(x48 - sep - arr, ya);
      ctx.stroke();
      ctx.fillText('HRDPS', xm, ya);
    } else {
      ctx.moveTo(chart_left + arr, ya); ctx.lineTo(x48 - sep - arr, ya); ctx.stroke();
    }
    ctx.beginPath();
    ctx.moveTo(chart_left + arr, ya - arr/2);  ctx.lineTo(chart_left, ya);  ctx.lineTo(chart_left + arr, ya + arr/2);
    ctx.moveTo(x48 - sep - arr, ya - arr/2);   ctx.lineTo(x48 - sep, ya);   ctx.lineTo(x48 - sep - arr, ya + arr/2);
    ctx.moveTo(x48, ya - arr); ctx.lineTo(x48, ya + arr);
    ctx.stroke();
    // RDPS
    tw = ctx.measureText('RDPS').width + 8;
    xm = (x48 + x84) / 2;
    ctx.beginPath();
    if (x84 - x48 > arr * 2 + sep * 2 + tw) {
      ctx.moveTo(x48 + sep + arr, ya); ctx.lineTo(xm - tw/2, ya);
      ctx.moveTo(xm + tw/2, ya);       ctx.lineTo(x84 - sep - arr, ya);
      ctx.stroke();
      ctx.fillText('RDPS', xm, ya);
    } else {
      ctx.moveTo(x48 + sep + arr, ya); ctx.lineTo(x84 - sep - arr, ya); ctx.stroke();
    }
    ctx.beginPath();
    ctx.moveTo(x48 + sep + arr, ya - arr/2); ctx.lineTo(x48 + sep, ya); ctx.lineTo(x48 + sep + arr, ya + arr/2);
    ctx.moveTo(x84 - sep - arr, ya - arr/2); ctx.lineTo(x84 - sep, ya); ctx.lineTo(x84 - sep - arr, ya + arr/2);
    ctx.moveTo(x84, ya - arr); ctx.lineTo(x84, ya + arr);
    ctx.stroke();
    // GDPS
    tw = ctx.measureText('GDPS').width + 8;
    xm = (x84 + chart_right) / 2;
    ctx.beginPath();
    if (chart_right - x84 > arr * 2 + sep + tw) {
      ctx.moveTo(x84 + sep + arr, ya); ctx.lineTo(xm - tw/2, ya);
      ctx.moveTo(xm + tw/2, ya);       ctx.lineTo(chart_right - arr, ya);
      ctx.stroke();
      ctx.fillText('GDPS', xm, ya);
    } else {
      ctx.moveTo(x84 + sep + arr, ya); ctx.lineTo(chart_right - arr, ya); ctx.stroke();
    }
    ctx.beginPath();
    ctx.moveTo(x84 + sep + arr, ya - arr/2);   ctx.lineTo(x84 + sep, ya);   ctx.lineTo(x84 + sep + arr, ya + arr/2);
    ctx.moveTo(chart_right - arr, ya - arr/2);  ctx.lineTo(chart_right, ya); ctx.lineTo(chart_right - arr, ya + arr/2);
    ctx.stroke();
  }

}
